// notice: if you make changes here, you have to change the mapping in "console" project too
// search for "MyCompanyTabs" in "CommonConsole/app/lib/constants.js"
import { SwitchValue } from '../purchase/purchasePage/types';

export enum MyCompanyTabIndex {
  Details,
  Authentication,
  Licensing,
  PlansAndPurchase,
  BetaPrograms,
}

export interface PurchaseTabParams {
  productId?: string;
  extend?: SwitchValue
}
